import { message } from 'antd'
import Context from '../Context'
import { useContext } from 'react'
import { useMutation } from 'react-query'
import axiosRequest from 'utils/axiosRequest'
// helpers
import get from 'lodash/get'
import authService from 'authService'
import useLogAction from 'hooks/useLogAction'

const authApp = process.env.REACT_APP_AUTH_URL

const manageUser = async ({ user, action }) => {
  const { data } = await axiosRequest({
    baseURL: authApp,
    url: `/user/status/${user}/${action}`,
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authService.state.authToken}`
    }
  })

  return data
}

const useManageUSer = setPopOpen => {
  const { logAction } = useLogAction()
  const {
    queryHandler: { data },
    states: { page },
    actions: { setDirtyBit, setPage }
  } = useContext(Context)

  const paginationInfo = get(data, 'paginationInfo', {
    currentPage: 1,
    recordsPerPage: 7,
    totalPages: 1,
    totalRecords: 1
  })

  const { isLoading, isError, mutate } = useMutation({
    mutationKey: 'manage_user',
    mutationFn: manageUser,
    onSuccess: () => {
      const { totalRecords, currentPage, totalPages } = paginationInfo
      setPopOpen(false)

      if (
        currentPage > Math.ceil((totalRecords - 1) / 9) &&
        currentPage !== 1
      ) {
        setPage(page - 1)
      } else setDirtyBit(true)

      message.success({
        type: 'success',
        content: 'Acción realizada con exito'
      })
    },
    onError: () => {
      message.error({
        type: 'error',
        content: 'Ha ocurrido un error'
      })
    }
  })

  const onClick = (user, action) => {
    mutate({ user: user.id, action }, {
      onSuccess: () => {
        logAction({
          event: "USER", action: "UPDATE", metadata: {
            actionType: `${action}Operator`,
            userInfo: {
              id: user.id,
              firstname: user.firstname,
              lastname: user.lastname,
              email: user.username,
              roles: user.roles
            }
          }
        })
      }
    })
  }

  return {
    isLoading,
    isError,
    onClick
  }
}

export default useManageUSer
